const Theme = {
  plain: {
    backgroundColor: '#f8f8fa',
    color: '#7a7a7a',
    overflow: 'hidden',
    margin: 0,
  },
  styles: [
    {
      types: ['comment', 'prolog', 'doctype', 'cdata', 'punctuation'],
      style: { color: '#b6ad9a' }
    },
    {
      types: ['namespace'],
      style: { opacity: 0.7 }
    },
    {
      types: ['tag', 'operator', 'number'],
      style: { color: '#063289' }
    },
    {
      types: ['property', 'function'],
      style: { color: '#b29762' }
    },
    {
      types: ['tag-id', 'selector', 'atrule-id'],
      style: { color: '#2d2006' }
    },
    {
      types: ['attr-name'],
      style: { color: '#896724' }
    },
    {
      types: [
        'boolean',
        'string',
        'entity',
        'url',
        'attr-value',
        'keyword',
        'control',
        'directive',
        'unit',
        'statement',
        'regex',
        'at-rule'
      ],
      style: { color: '#728fcb' }
    },
    {
      types: ['placeholder', 'variable'],
      style: { color: '#93abdc' }
    },
    {
      types: ['deleted'],
      style: { textDecorationLine: 'line-through' }
    },
    {
      types: ['inserted'],
      style: { textDecorationLine: 'underline' }
    },
    {
      types: ['italic'],
      style: { fontStyle: 'italic' }
    },
    {
      types: ['important', 'bold'],
      style: { fontWeight: 'bold' }
    },
    {
      types: ['important'],
      style: { color: '#896724' }
    }
  ],
  lineNumber: {
    borderRight: '1px solid #d8d8d8',
    color: '#d8d8d8',
    padding: '0 10px',
  }
};

export default Theme;



// WEBPACK FOOTER //
// ./src/components/Code/Theme.js